import { type ReactNode } from 'react';
import { containsUrlParam } from '../../utils/containsUrlParam';

type Props = {
  children: ReactNode;
  urlParams: string[];
};

export const ConditionallyHideWithUrlParam = ({
  children,
  urlParams,
}: Props) => {
  const hideChildren = urlParams.every((param) =>
    containsUrlParam({ param, location: window.location })
  );
  if (hideChildren) {
    return null;
  }
  return <>{children}</>;
};
